"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseAttributes = void 0;
/**
 * Case attributes
 */
class CaseAttributes {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return CaseAttributes.attributeTypeMap;
    }
}
exports.CaseAttributes = CaseAttributes;
/**
 * @ignore
 */
CaseAttributes.attributeTypeMap = {
    archivedAt: {
        baseName: "archived_at",
        type: "Date",
        format: "date-time",
    },
    closedAt: {
        baseName: "closed_at",
        type: "Date",
        format: "date-time",
    },
    createdAt: {
        baseName: "created_at",
        type: "Date",
        format: "date-time",
    },
    description: {
        baseName: "description",
        type: "string",
    },
    jiraIssue: {
        baseName: "jira_issue",
        type: "JiraIssue",
    },
    key: {
        baseName: "key",
        type: "string",
    },
    modifiedAt: {
        baseName: "modified_at",
        type: "Date",
        format: "date-time",
    },
    priority: {
        baseName: "priority",
        type: "CasePriority",
    },
    serviceNowTicket: {
        baseName: "service_now_ticket",
        type: "ServiceNowTicket",
    },
    status: {
        baseName: "status",
        type: "CaseStatus",
    },
    title: {
        baseName: "title",
        type: "string",
    },
    type: {
        baseName: "type",
        type: "CaseType",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=CaseAttributes.js.map